/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Bookmark = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 10 16">
      <path
        transform="translate(-758.000000, -1080.000000)"
        d="M766.777778,1096 C766.555556,1096 766.333333,1096 766.222222,1095.89809 L763,1094.16561 L759.777778,1095.79618 C759.333333,1096 758.777778,1096 758.333333,1095.59236 C758.111111,1095.38854 758,1095.0828 758,1094.77707 L758,1080.50955 C758,1080.20382 758.222222,1080 758.555556,1080 L767.444444,1080 C767.777778,1080 768,1080.20382 768,1080.50955 L768,1094.77707 C768,1095.49045 767.444444,1096 766.777778,1096 Z M763,1093.1465 C763.228571,1093.1465 763.457143,1093.1465 763.571429,1093.24841 L766.885714,1094.87898 C766.885714,1094.87898 767,1094.87898 767,1094.77707 L767,1081.12102 L759,1081.12102 L759,1094.87898 L759.114286,1094.98089 L762.428571,1093.35032 C762.542857,1093.24841 762.771429,1093.1465 763,1093.1465 Z"
      />
    </BaseSvgIcon>
  )
}

export default Bookmark
